import React from "react";

const ErrorState = ({ title = "Something went wrong", description, onRetry }) => (
  <div className="flex min-h-[240px] items-center justify-center rounded-2xl border border-rose-200 bg-rose-50 px-6 py-12 text-center">
    <div className="max-w-md space-y-4">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-rose-500 shadow-sm">
        <svg className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <div>
        <h3 className="text-base font-semibold text-rose-900">{title}</h3>
        <p className="mt-2 text-sm text-rose-700">{description || "Please try again."}</p>
      </div>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center rounded-lg bg-rose-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-rose-700"
        >
          Retry
        </button>
      ) : null}
    </div>
  </div>
);

export default ErrorState;
